import { initializeMap } from './components/Map';


import './index.css';
import 'simple-notify/dist/simple-notify.min.css';
import { InitDropDown, addLabelForSelect, _onChange, addWraperForSelect } from './components/LoadDropDown';

import {
  queryTaskAsync,
  queryMode,
  zoomToFeature,
  addGraphicToMap,
  createElement,
  addGraphicLayer,
  addGraphic,
  groupBy,
  centerAndZoom,
  addGraphicOnEdite
} from './utils/arc-gis';

import { initLoading, showHideLoading } from './components/loading/loading';

import PopupTemplate from "@arcgis/core/PopupTemplate";

import axios from 'axios';
import searchIcon from './assets/images/search.svg'
import { showNotification, readFile, applicationDomain, getConfig } from './utils/common';


import * as geometryEngineAsync from "@arcgis/core/geometry/geometryEngineAsync";
import pinMarker from './assets/images/pin.png';
import okImage from './assets/images/Ok.png';


import { generateGUID } from './utils/common';

import { SittersData } from './services/data-service';
import { Sitters } from './services/sitters';
import { SittersValidation } from './services/sitters-validation';

var AppData;
var options = {};

let sellingPortType;
let accessToken;
let sitterGraphicLayer;
let sitterPointGraphicLayer;
let exportedFeatureToGoogle;
var dataService;
var initValidation;
var sittersValidation;

/**
 * loadMap function is the Main for street-vendors-view application
 * @param {*} config 
 * @returns 
 */
export async function loadMap(config) {
  /**
   * READ APPLICATION CONFIG*    
   */
  const readFileRespones = await readFile('$(appSettings.key)', false);

  if (!readFileRespones) {
    showNotification('error', `${'👈'} خطا`, 'مشكلة فى استرجاع البيانات الخاصة بالتطبيق برجاء المحاولة مرة اخرى');
    return;
  }
  AppData = readFileRespones;

  console.log("config", config);

  /**
   * initialize sitter class with input config
   */
  new Sitters(config);
  dataService = new SittersData(config);
  initValidation = new SittersValidation(config);
  sittersValidation = initValidation.sittersAppMode();
  console.log(initValidation.sittersAppMode());

  AppData.isProduction == false ? console.log(readFileRespones) : null;
  options = {
    vectorTileURL: AppData.vectorTileURL,
    mapDivId: null
  }
  AppData.isProduction == false ? console.log('dataFile', readFileRespones) : null;

  if (!('initializeMap' in AppData) || ('initializeMap' in AppData && AppData.initializeMap == false)) {
    AppData.config = config;
    sellingPortType = config.sellingPortType;
    options.mapDivId = config.mapDivId
    initializeMap(options, true, AppData).then(async mapView => {
      debugger
      mapView.on("layerview-create-error", function (event) {
        console.error("LayerView failed to create for layer with the id: ", event.layer.id);
      });
      // dataService.config = config;
      // dataService.applicationSettings = AppData;

      AppData.isProduction == false ? console.log('dataService', dataService) : undefined;

      //AppData.googleMode = sittersValidation.isGoogleMode //isExportGoogleMode(AppData.config);
      //AppData.sitterRenewal =  sittersValidation.isSittersRenewer //sitterRenewalCheck(AppData.config);

      let urlReq = `${AppData.apiendpoint.appRequest}`;
      if (!AppData.config.hasOwnProperty('clientId')) {
        showNotification('error', `${'👈'} خطا`, 'لا يوجد صلاحية للقيام بمهام الخريطه');
        return;
      }
      if (AppData.config.hasOwnProperty('clientId') && !AppData.config.clientId.length > 0) {
        showNotification('error', `${'👈'} خطا`, 'لا يوجد صلاحية للقيام بمهام الخريطه');
        return;
      }

      sitterGraphicLayer = addGraphicLayer("sitter", mapView);
      sitterPointGraphicLayer = addGraphicLayer("sitterPoint", mapView);
      AppData.isProduction == false ? console.log('sitterGraphicLayer is ready', mapView) : null;
      AppData.isProduction == false ? console.log('sitterPointGraphicLayer is ready', mapView) : null;
      AppData.isProduction == false ? console.log('map is ready', mapView) : null;
      //showDataOnHover(mapView, sitterGraphicLayer);
      addMapClickEvent(mapView, sitterGraphicLayer);
      AppData.mapView = mapView;
      AppData.isProduction == false ? console.log('AppData', AppData) : null;

      /**
       * cascading-dropDown render
       */
      let items = await InitDropDown(AppData.dropDown, onSelectChange, AppData);

      AppData.isProduction == false ? console.log(items) : null;
      const mapDiv = document.querySelector(`#${options.mapDivId}`);

      // start check
      /**
       * implement new behavior for map to export incubator to google map
       * to show or hide some features related with application mode 
       */
      if (!sittersValidation.isGoogleMode && !sittersValidation.isSittersRenewer) {


        /**
         * start render dropDowns
         */
        let dropDowncontainer = document.querySelector('#dropDown-container');
        let searchBtn = document.querySelector('#search-btn');
        let searchIcon = document.querySelector('#search-icon');


        if (!dropDowncontainer) {
          dropDowncontainer = document.createElement('div');
          dropDowncontainer.id = "dropDown-container";
          dropDowncontainer.className = "dropDown-container animate__animated animate__fadeIndown";
          mapDiv.appendChild(dropDowncontainer);
        }




        if (!searchBtn) {
          searchBtn = document.createElement('button');
          searchBtn.id = "search-btn";
          searchBtn.type = "button";
          searchBtn.className = "toggle"
          mapDiv.appendChild(searchBtn);
        }

        if (!searchIcon) {
          searchIcon = document.createElement('i');
          searchIcon.className = "bx bx-filter-alt toggle";//"bx bx-search toggle";
          searchBtn.innerHTML = "التفاصيل";
          searchBtn.appendChild(searchIcon);
        }



        var itemByKeys = Object.keys(items);
        /**
         * dropdown render
         */
        //if(document.querySelectorAll('.dropDown-container div').length > 0) return;
        document.querySelectorAll('.dropDown-container')[0].innerHTML = "";

        const toggle = document.querySelector(".toggle");
        toggle.onclick = () => {
          dropDowncontainer.classList.toggle("open");
        }

        for (let i = 0; i < itemByKeys.length; i++) {
          const el = itemByKeys[i];
          let wraperDiv = addWraperForSelect(mapDiv, items[el].element.id);

          if (sellingPortType === false) {
            if (wraperDiv.id === "wraper-select-sellingPort") {
              wraperDiv.style.display = 'none';
            }
          } else if (sellingPortType === true) {
            if (wraperDiv.id === "wraper-select-sellingPort") {
              wraperDiv.style.display = 'block';
            }
          }



          addLabelForSelect(wraperDiv, items[el].element.id, items[el].label);
          wraperDiv.appendChild(items[el].element);
          dropDowncontainer.appendChild(wraperDiv);
          $(`#${items[el].element.id}`).select2({
            dropdownAutoWidth: true,
            width: '100%',

          });
        }

        bindRegions();
        if (AppData.config.hasOwnProperty("showRegions") && !AppData.config.showRegions || (!AppData.config.hasOwnProperty("showRegions"))) {
          bindAllCities();  // return all cities if hide Regions
        }

        /****** this condition for check edit mode to load allcities added by Matroud */

        if (AppData.config.GUID != "" && AppData.config.isEditable)
          bindAllCities();


        //else
        //bindRegions();
        ////bindCities();
      }
      // end check

      /**
       * google map mode
       */
      if (sittersValidation.isGoogleMode) {
        debugger
        exportedFeatureToGoogle = await getIncubatorByGUID(AppData);
        AppData.isProduction == false ? console.log(exportedFeatureToGoogle) : null;
        if (exportedFeatureToGoogle.features.length > 0) {
          addGraphic(sitterGraphicLayer, exportedFeatureToGoogle.features[0], false);
          zoomToFeature(exportedFeatureToGoogle.features[0].geometry, AppData.mapView);
          showMapPopupUpdForExportToGoogleMap(exportedFeatureToGoogle.features[0], AppData.mapView, exportedFeatureToGoogle.features[0].geometry.centroid)
        } else {
          //alert('الحاضنة غير موجودة بقاعدة البيانات الجغرافية'); تم التعديل
          showNotification('error', `${'👈'} خطا`, 'الحاضنة غير موجودة بقاعدة البيانات الجغرافية')
        }
      }

      /**
       *  sitters renewer
      */
      if (sittersValidation.isSittersRenewer) {
        let incubatorFeature = await getIncubatorByGUID(AppData);
        AppData.isProduction == false ? console.log(incubatorFeature) : null;
        if (incubatorFeature.features.length > 0) {
          addGraphic(sitterGraphicLayer, incubatorFeature.features[0], false);
          zoomToFeature(incubatorFeature.features[0].geometry, AppData.mapView);
        } else {
          showNotification('error', `${'👈'} خطا`, 'الحاضنة غير موجودة بقاعدة البيانات الجغرافية')
        }
      }

      AppData.isProduction == false ? console.log(items) : null;
      mapView.popup.on("trigger-action", function (event) {
        if (event.action.id === "incubator-detail") {
          getIncubatorDetailItem();
        }
        else if (event.action.id === "sendToGoogle") {
          sendToGoole(exportedFeatureToGoogle.features[0].geometry.centroid);
        }
      });
      AppData.initializeMap = true;
      mapView.watch("scale", () => {
        if (mapView.zoom > 12) {
          sitterPointGraphicLayer.opacity = 0;
        } else {
          sitterPointGraphicLayer.opacity = 1;
        }
      });
    });
  }
  document.querySelector('.overlay') == null ? initLoading(`#${options.mapDivId}`) : undefined;
}

// function addSelect2minInHeaderPage(src) {
//   var imported = document.createElement('script');
//   imported.src = src;
//   document.head.appendChild(imported);
// }

// function isScriptLoaded(src) {
//   return Boolean(document.querySelector('script[src="' + src + '"]'));
// }

function getIncubatorDetailItem() {
  AppData.config.getIncubator(AppData.selectedFeatureItem);
  /**
   * send incubator data using iframe
   */
  parent.postMessage(AppData.selectedFeatureItem, "*");
}

/********* added by Matroud ****/
function getRegionsData(options) {
  debugger;
  showHideLoading('block');
  return dataHandler(options).then(redData => {
    showHideLoading('none');
    return redData.features.map(item => { return { item: item.attributes, geometry: item.geometry } });
  }, err => showNotification('error', `${'👈'} خطا`, 'خطأ فى استرجاع طبقة المناطق'));
}

function getAllCitiesData(options) {
  showHideLoading('block');
  return dataHandler(options).then(redData => {
    showHideLoading('none');
    return redData.features.map(item => { return { item: item.attributes, geometry: item.geometry } });
  }, err => showNotification('error', `${'👈'} خطا`, 'خطأ فى استرجاع طبقة المدن'));
}
/***************************** */
/*** it was used dataHandlerUsingGometry for geomentry filter */
function getCitiesData(options) {
  showHideLoading('block');
  return dataHandlerUsingGometry(options).then(redData => {
    showHideLoading('none');
    return redData.features.map(item => { return { item: item.attributes, geometry: item.geometry } });
  }, err => showNotification('error', `${'👈'} خطا`, 'خطأ فى استرجاع طبقة المدن'));
}

function getDistrectData(options) {
  showHideLoading('block');
  return dataHandlerUsingGometry(options).then(redData => {
    showHideLoading('none');
    return redData.features.map(item => { return { item: item.attributes, geometry: item.geometry } });
  });
}

function getStreetData(options) {
  showHideLoading('block');
  return dataHandlerUsingGometry(options).then(streetData => {
    showHideLoading('none');
    return streetData.features.map(item => { return { item: item.attributes, geometry: item.geometry } });
  });
}

/*** added by matroud */
async function bindRegions() {
  let regionSelect = document.querySelector('#regions');

  let regionsOptions = {
    LayerURL: AppData.Regions,
    where: "1=1",
    outFields: ['REGIONCODE', 'REGIONARNAME'],

  }
  let loadRegionsData = await getRegionsData(regionsOptions);
  debugger;
  //console.log('rrrigion');
  //console.log(loadRegionsData);
  loadRegionsData.length > 0 && AppData.isProduction == false ? console.log('بيانات المناطق') : null;

  AppData.regionsData = loadRegionsData; /*** for review ***/
  AppData.isProduction == false ? console.log(AppData) : null;
  bindOptionToSelect(regionSelect, loadRegionsData, 'REGIONCODE', 'REGIONARNAME', null, null);
  regionSelect.length > 0 ? regionSelect.disabled = false : regionSelect.disabled = true;

}

async function filterCities(cities) {
  try {
    let sitterApiUrl = `${AppData.amanaCitiesApi}/${AppData.config.amanaCode}`
    let url = sitterApiUrl;
    let citiesRes = await axios.post(url, {
      "incubatorToken": AppData.config.clientId
    }, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).catch(e => {
      this.errors.push(new DataError('filterCities', e))
    })

    let allowedCities = citiesRes.data.data.result.map(r => r.id);

    cities = cities.filter(c => allowedCities.map(ac => "" + ac).includes("" + c.item["CITEYCODE"]))

    console.log(cities.map(c => c.item["CITEYCODE"]), allowedCities);

    return cities;
  } catch (error) {
    throw error;
  }
}

/***** this function to get all cities when IsEditMode = true and guid not null  *****/
async function bindAllCities() {
  debugger
  let citiesSelect = document.querySelector('#cities');
  let citiesOptions = {
    LayerURL: AppData.Cites,
    outFields: ['CITEYCODE,CITEYARNAME'],
    where: "1=1"
  }
  let loadAllCitesData = await getAllCitiesData(citiesOptions);

  if (AppData.config.amanaCode) {
    loadAllCitesData = await filterCities(loadAllCitesData);
  }

  loadAllCitesData.length > 0 && AppData.isProduction == false ? console.log('تم تجهيز بيانات المدن') : null;
  AppData.citiesData = loadAllCitesData;
  AppData.isProduction == false ? console.log(AppData) : null;
  bindOptionToSelect(citiesSelect, loadAllCitesData, 'CITEYCODE', 'CITEYARNAME', null, null);
  citiesSelect.length > 0 ? citiesSelect.disabled = false : citiesSelect.disabled = true;
  //document.getElementById("#regions").hidden = true;

  //console.log(loadCitesData);
}

/********************* */


async function bindCities() {
  debugger
  let citiesSelect = document.querySelector('#cities');

  let citiesOptions = {
    LayerURL: AppData.Cites,
    where: "1=1",//Where: 'REGIONCODE = 003', /** value for test only */
    outFields: ['CITEYCODE,CITEYARNAME'],
    geometry: undefined
  }
  let loadCitesData = await getCitiesData(citiesOptions);
  loadCitesData.length > 0 && AppData.isProduction == false ? console.log('تم تجهيز بيانات المدن') : null;
  AppData.citiesData = loadCitesData;
  AppData.isProduction == false ? console.log(AppData) : null;
  bindOptionToSelect(citiesSelect, loadCitesData, 'CITEYCODE', 'CITEYARNAME', null, null);
  citiesSelect.length > 0 ? citiesSelect.disabled = false : citiesSelect.disabled = true;
  //console.log(loadCitesData);
}

export function bindOptionToSelect(parentSelect, data, colVal, colTxt, colTxt2 = null, placeHolderTxt = null) {

  let children = parentSelect.childNodes.length;

  if (children > 1) {
    return;
  }

  if (data) {
    data = [...new Map(data.map(item =>
      [item.item[Object.keys(item.item)[0]], item])).values()];
  }

  let option = null;
  let distrectItems;
  let distrectitembyGroups;
  parentSelect.id == "distrect" ? distrectItems = data.map(el => el.item) : undefined;
  parentSelect.id == "distrect" ? distrectitembyGroups = groupBy(distrectItems, "DISTRICTARNAME") : undefined;
  AppData.isProduction == false ? console.log(distrectitembyGroups) : null;
  if (placeHolderTxt != null) {
    let optionPlaceHolder = document.createElement("option");
    optionPlaceHolder.value = "";
    optionPlaceHolder.text = placeHolderTxt;
    parentSelect.appendChild(optionPlaceHolder);
  }
  for (let index = 0; index < data.length; index++) {
    const el = data[index];
    option = document.createElement("option");
    option.value = data[index].item[colVal];
    // if (distrectitembyGroups[data[index].item[colTxt]].length > 1) {
// updated by mahmood - for Error
   // if (parent.id != "distrect") {

     // mahmd
    if (parentSelect.id != "distrect") {
     
      option.text = data[index].item[colTxt]
    } else {
      if (distrectitembyGroups[data[index].item[colTxt]].length > 1) {
        if (data[index].item[colTxt2] != null) {
          option.text = colTxt2 == null ? data[index].item[colTxt] :
            `${data[index].item[colTxt]} - ${data[index].item[colTxt2]}`;
        } else {
          option.text = colTxt2 == null ? data[index].item[colTxt] :
            `${data[index].item[colTxt]} - ${data[index].item['MUNICIPALITY']}`;
        }
      } else {
        option.text = data[index].item[colTxt];
      }
    }

    // if (data[index].item[colTxt2] != null) {
    //   option.text = colTxt2 == null ? data[index].item[colTxt] :
    //     `${data[index].item[colTxt]} - ${data[index].item[colTxt2]}`;
    // } else {
    //   option.text = colTxt2 == null ? data[index].item[colTxt] :
    //     `${data[index].item[colTxt]} - ${data[index].item['MUNICIPALITY']}`;
    // }

    // }else{
    //   option.text = data[index].item[colTxt]
    // }
    parentSelect.appendChild(option);
  }

  /* disabled cities dropdown if isEditable true */
  debugger
  //
  if (AppData.config.isEditable) {
    $("#regions").prop("display", "none");
    if (parentSelect.id == "cities") {
      $("#cities").prop("disabled", true);
      document.getElementById("cities").value = AppData.config.cityId;

      getCitiesGeometry(AppData.config.cityId);
    }
  }


  //if (parentSelect.id == "cities" && AppData.config.isEditable) {
  // $("#cities").prop("disabled", true);
  // $("#regions").prop("display", "none");    
  //document.getElementById("cities").value = AppData.config.cityId;

  // // if(document.getElementById("#cities").disabled == false) {
  // //   document.getElementById("#cities").disabled = true;
  // // }

  // getCitiesGeometry(AppData.config.cityId);
  // }



}

// function showDataOnHover(mapView, graphicLayer) {
//   mapView.whenLayerView(graphicLayer).then(lview => {
//     mapView.on("pointer-move", evt => {
//       mapView.hitTest(event, { exclude: mapView.graphics })
//         .then(async response => {
//           if (response.results.length > 1 && response.results[0].graphic.attributes) {
//             //console.log(response.results[0].graphic.attributes)
//             let mapPoint = response.results[0].mapPoint;
//             //showMapPopup(mapView, mapPoint, popupContent(response.results[0].graphic.attributes))
//           }
//         })
//     })
//     // mapView.on("pointer-leave", evt => {
//     //   mapView.popup.close();
//     // });
//   })
// }

function addMapClickEvent(mapView, graphicLayer) {
  //mapView.whenLayerView(graphicLayer).then(lview => {
  mapView.on('click', evt => {
    mapView.hitTest(evt, { exclude: mapView.graphics }).then(async response => {
      if (response.results.length > 0 && response.results[0].graphic.attributes) {
        //AppData.isProduction == true ? undefined : console.log('addMapClickEvent', response);
        let mapPoint = response.results[0].mapPoint;

        // if (sellingPortType === false) {
        //   response.results[0].graphic.attributes.sellingPortType = "201";
        //   response.results[0].graphic.attributes.sellingPortTypeName = "منفذ بيع تجاري";
        // } else {
        //   let sellingPortTypeName = AppData.sellingPortDropdownValue == "202" ? "منفذ بيع حرفي" : "منفذ بيع تجاري";
        //   response.results[0].graphic.attributes.sellingPortType = AppData.sellingPortDropdownValue;
        //   response.results[0].graphic.attributes.sellingPortTypeName = sellingPortTypeName;
        // }
        // AppData.selectedFeatureItem = response.results[0].graphic.attributes;
        if (!sittersValidation.isGoogleMode) {
          !sittersValidation.isSittersRenewer ? getSelectedItemDetail(response.results[0].graphic.attributes) : null;
          !sittersValidation.isSittersRenewer ? showMapPopupUpd(response.results[0].graphic, mapView, mapPoint) : null;
        }
        else {
          sendToGoole(exportedFeatureToGoogle.features[0].geometry.centroid);
        }


        if (sittersValidation.isEditeMode) {
          mapView.graphics.removeAll();
          addGraphicToMap(response.results[0].graphic.geometry, mapView);
        }
      }
    })
  })
  //});
}

function getSelectedItemDetail(feature) {
  if (sittersValidation.isSitterPortPaths) {
    feature.sellingPortType = parseInt(AppData.config.sitterPortPaths);
    feature.sellingPortTypeName = "حجز موقع لرخصة عربة متنقلة";
    AppData.selectedFeatureItem = feature;
    return false;
  }
  if (sellingPortType === false) {
    feature.sellingPortType = "201";
    feature.sellingPortTypeName = "منفذ بيع تجاري";
  } else {
    let sellingPortTypeName = AppData.sellingPortDropdownValue == "202" ? "منفذ بيع حرفي" : "منفذ بيع تجاري";
    feature.sellingPortType = AppData.sellingPortDropdownValue;
    feature.sellingPortTypeName = sellingPortTypeName;
  }
  AppData.selectedFeatureItem = feature;
}

function popupContent(data) {
  let content = `
      <div class="popup-container">
        <div class="popup-detail">
            <span><strong>📅 تاريخ البداية : </strong> ${data.attributes.startDate}</span><br />
            <span><strong>📅 تاريخ النهاية : </strong> ${data.attributes.endDate}</span>
        </div>
      </div>
  `;
  return content;
}

// function popupContentForGoogleMapExport(data) {
//   let content = `
//       <div class="popup-container">
//         <div>${data.attributes.startDate}</div>
//       </div>
//   `;
//   return content;
// }

var incubatorDetail = {
  title: "موافق",
  id: "incubator-detail",
  style: "color:#fff",
  image: okImage
};

var exportToGoogle = {
  id: 'sendToGoogle',
  image: pinMarker,
  className: 'location',
  title: " "
};

function showMapPopupUpd(data, view, mapPoint) {
  let title = data.attributes.name;
  data.popupTemplate = new PopupTemplate({
    title: `👈 ${title}`,
    content: popupContent(data),
    actions: [incubatorDetail],
    outFields: ["*"]
  });
  view.popup.open({
    features: [data],
    location: mapPoint
  })
}

function showMapPopupUpdForExportToGoogleMap(data, view, mapPoint) {
  let title = 'عرض الحاضنة على جوجل';
  data.popupTemplate = new PopupTemplate({
    title: title,
    content: '',
    actions: [exportToGoogle],
    outFields: ["*"]
  });
  view.popup.open({
    features: [data],
    featureMenuOpen: true,
    location: mapPoint
  })
}

// function _showMapPopup(view, mapPoint, content) {
//   
//   view.popup.open({
//     features: [content],
//     location: mapPoint
//   });
// }

// function showMapPopup(view, mapPoint, content) {
//   view.popup.open({
//     title: 'title',
//     location: mapPoint,
//     content: content
//   })
//   console.log('showMapPopup', view.popup);
// }

/*********** added By Matroud *******/

//async function getRegionByGUID(guid){

//}


async function getRegionsGeometry(id) {
  AppData.dropDown.distrect.data = null;
  AppData.regionsValueDropdown = id;
  let citySelect = document.querySelector('#cities');
  let distrectSelect = document.querySelector('#distrect');
  let streetsSelect = document.querySelector('#streets');
  citySelect.options.length = 0;
  distrectSelect.options.length = 0;
  streetsSelect.options.length = 0;

  let index = AppData.regionsData.findIndex(el => el.item.REGIONCODE === id)
  if (index != -1) {
    let geometry = AppData.regionsData[index].geometry;

    /* 
    check on Application which mode view or edit    
    */
    /**
     * aboulmagd
     * remove the condation not match the bussines
     */
    debugger
    // if (sittersValidation.isEditeMode) {
    addGraphicToMap(geometry, AppData.mapView);
    zoomToFeature(geometry, AppData.mapView);
    // }
    let cityOptions = {
      LayerURL: AppData.Cites,
      where: `REGIONCODE = '${id}'`,
      outFields: ['CITEYCODE,CITEYARNAME'],
      spatialRelationship: "contains",
      geometry: null,
      distance: 10,
      units: "meters"
    }
    let data = await getCitiesData(cityOptions);
    AppData.dropDown.cities.data = data;
    AppData.citiesData = data;

    bindOptionToSelect(citySelect, data, 'CITEYCODE', 'CITEYARNAME', null, 'اختر المدينة');
    citySelect.length > 0 ? citySelect.disabled = false : citySelect.disabled = true;
    AppData.isProduction == true ? undefined : console.log(data);
    AppData.isProduction == false ? console.log(AppData.regionsData[index]) : null;
  }
  else {
    citySelect.options.length = 0;
    distrectSelect.options.length = 0;
    streetsSelect.options.length = 0;
    citySelect.disabled = true;
    distrectSelect.disabled = true;
    streetsSelect.disabled = true;
  }

  /* 
   stopped for bug no load sitter by region , load sitter for select city   
    */
  // loadSitterBasedOnMode(accessToken, id, null, null, AppData.sellingPortDropdownValue || 201, 'regions'); /*** Modified by matroud */
}

/************************************/


async function getCitiesGeometry(id) {
  AppData.dropDown.distrect.data = null;
  AppData.citiesValueDropdown = id;
  let distrectSelect = document.querySelector('#distrect');
  let streetsSelect = document.querySelector('#streets');
  distrectSelect.options.length = 0;
  streetsSelect.options.length = 0;

  let index = AppData.citiesData.findIndex(el => el.item.CITEYCODE === id)
  if (index != -1) {
    let geometry = AppData.citiesData[index].geometry;

    /* 
    check on Application which mode view or edit    
    */
    /**
     * aboulmagd
     * remove the condation not match the bussines
     */
    debugger
    // if (sittersValidation.isEditeMode) {
    addGraphicToMap(geometry, AppData.mapView);
    zoomToFeature(geometry, AppData.mapView);
    // }

    let distrectOptions = {
      LayerURL: `${AppData.MomraBasemap}/${AppData.layerIndexInMomraBasemap.District}`, //AppData.Distrect,
      where: "1=1",
      outFields: ['DISTRICTCODE,DISTRICTARNAME,MUNICIPALITY,SUBMUNICIPALITY'],
      spatialRelationship: "contains",
      geometry: geometry
    }
    let data = await getDistrectData(distrectOptions);
    AppData.dropDown.distrect.data = data;
    bindOptionToSelect(distrectSelect, data, 'DISTRICTCODE', 'DISTRICTARNAME', 'SUBMUNICIPALITY', 'اختر الحى');
    distrectSelect.length > 0 ? distrectSelect.disabled = false : distrectSelect.disabled = true;
    AppData.isProduction == true ? undefined : console.log(data);
    AppData.isProduction == false ? console.log(AppData.citiesData[index]) : null;
  } else {
    distrectSelect.options.length = 0;
    streetsSelect.options.length = 0;
    distrectSelect.disabled = true;
    streetsSelect.disabled = true;
  }

  /* 
    check on Application which mode view or edit to show data   
    */
  loadSitterBasedOnMode(accessToken, id, null, null, AppData.sellingPortDropdownValue || 201, 'cities');
}

async function loadSitterBasedOnMode(token, cities, distrect, street, portType, dropDownItem) {
  debugger
  if (sittersValidation.isEditeMode) {
    debugger
    getIncubatorData(AppData.config.guid, dropDownItem);
  }
  if (isSitterPortPaths(AppData.config)) {
    //loadSitterData(token, cities, distrect, street, 203);
    loadSitterData_(cities, distrect, street, 203)
  } else {
    //loadSitterData(accessToken, id, null, null, AppData.sellingPortDropdownValue || 201);
    loadSitterData_(cities, distrect, street, portType);
  }
}

async function loadSitterData_(cities, distrect, street, portType) {
  sitterGraphicLayer.removeAll();
  sitterPointGraphicLayer.removeAll();
  showHideLoading('block');
  let SitterData = null;
  let portTypeParam;
  try {
    sellingPortType = dataService.isSellingPortType(AppData.config);
    portTypeParam = dataService.isSitterPortPaths(AppData.config) == true ? parseInt(AppData.config.sitterPortPaths) : 201;
    let sitterOptions;
    distrect == null ? distrect = undefined : distrect;
    street == null ? street = undefined : street;
    portType = sellingPortType == true ? portType : portTypeParam;

    sitterOptions = {
      apiUrl: AppData.sittersApi,
      cities: cities,
      portType: portType,
      distrect: distrect,
      street: street,
      clientId: AppData.config.clientId
    }
    let sitterDataReady = await dataService.loadSitters(sitterOptions);
    debugger
    if (sitterDataReady == null && !dataService.errors.length > 0) {
      showNotification('error', `${'👈'} خطا`, 'عزيزي المستفيد.. لا يوجد حاضنة في المدينة التي، قمت باختيارها يرجى اختيار مدينة أخرى');
      showHideLoading('none');
      return;
    }
    if (sitterDataReady == "Ok" && !dataService.errors.length > 0) {
      if (dataService.Sitters.length > 0) {
        SitterData = dataService.Sitters[0];
      }
    } else {
      if (dataService.errors.length > 0) {
        if (dataService.errors[0].data.response.status == 401) {
          showNotification('error', `${'👈'} خطا`, 'لا يوجد صلاحية للقيام بمهام الخريطه');
          showHideLoading('none');
        };
        return;
      }
      showHideLoading('none');
      return;
    }
    debugger
    let migratedData = await getGisDataMigratedWithBaladyData(SitterData);
    let sitterPointFeature = [];
    if (migratedData.features.length > 0) {
      for (let index = 0; index < migratedData.features.length; index++) {
        const el = migratedData.features[index];
        addGraphic(sitterGraphicLayer, el, false);
        sitterPointFeature = el;
        sitterPointFeature.geometry = el.geometry.centroid;
        addGraphic(sitterPointGraphicLayer, sitterPointFeature, false, AppData.assets.images.mapMarker);

      }
      showHideLoading('none');
    } else {
      showNotification('info', `${'👈'} خطا`, 'لا توجد بيانات جغرافية للبيانات المرسله');
      showHideLoading('none');
      return;
    }
  } catch (error) {
    console.log(error);
    showHideLoading('none');
  }
}

// async function loadSitterData(token, cities, distrect, street, portType) {
//   sitterGraphicLayer.removeAll();
//   sitterPointGraphicLayer.removeAll();
//   showHideLoading('block');
//   try {
//     let SitterData = null;
//     if (sellingPortType == true) {
//       SitterData = await getSitterData(token, cities, distrect, street, portType);
//     } else {
//       //console.log(parseInt(AppData.config.sitterPortPaths));

//       let PortTypeParam = isSitterPortPaths(AppData.config) == true ? parseInt(AppData.config.sitterPortPaths) : 201;
//       SitterData = await getSitterData(token, cities, distrect, street, PortTypeParam);
//     }
//     if (SitterData.data.data.responseCode === 2) {
//       //alert('عزيزي المستفيد.. لا يوجد حاضنة في المدينة التي، قمت باختيارها يرجى اختيار مدينة أخرى');
//       showNotification('error', `${'👈'} خطا`, 'عزيزي المستفيد.. لا يوجد حاضنة في المدينة التي، قمت باختيارها يرجى اختيار مدينة أخرى');
//       showHideLoading('none');
//       return;
//     }
//     if (typeof (SitterData) !== 'undefined' && SitterData.data.data.responseCode === 1) {
//       let migratedData = await getGisDataMigratedWithBaladyData(SitterData.data.data.result);
//       let sitterPointFeature = [];
//       if (migratedData.features.length > 0) {
//         for (let index = 0; index < migratedData.features.length; index++) {
//           const el = migratedData.features[index];

//           addGraphic(sitterGraphicLayer, el, false);
//           sitterPointFeature = el;
//           sitterPointFeature.geometry = el.geometry.centroid;
//           addGraphic(sitterPointGraphicLayer, sitterPointFeature, false, AppData.assets.images.mapMarker);

//         }
//         // sitterGraphicLayer.opacity = 0;
//         showHideLoading('none');
//         // let geometries = migratedData.features.map(feature => feature.geometry);
//         // let geometry = await geometryEngineAsync.union(geometries);
//         //zoomToFeature(geometry, AppData.mapView);
//         // setTimeout(() => {
//         //   centerAndZoom(AppData.mapView, geometry.centroid, 5);
//         // }, 100);
//       }
//     }
//     else {
//       //alert('الخدمة غير متاحة برجاء مراجعه فريق التكامل');
//       showNotification('error', `${'👈'} خطا`, 'الخدمة غير متاحة برجاء مراجعه فريق التكامل');
//     }
//   } catch (error) {
//     console.log(error);
//     showHideLoading('none');
//   }
// }
// function checkOnSitterId(config) {
//   if (config.hasOwnProperty('sitterId') && config.sitterId.length > 0) {
//     return true;
//   }
//   return false;
// }

async function getIncubatorData(Guid, dropDownItem) {
  debugger
  if (!sittersValidation.isSitterId) {
    showNotification('error', `${'👈'} خطا`, 'البيانات المرسلة غير مكتملة برجاء ارسال رقم الحاضنة');
    return;
  }
  options = {
    LayerURL: AppData.streetVendorMapServer,
    where: `GUID='${Guid}'`,
    outFields: ['GUID']
  }
  // let gisData = await getgeometryUsingGUID(options);
  let settings = {
    // sitterApiToken: AppData.apigee.testEnv.apiUrl.token,
    // sitterApiTokenUser: AppData.apigee.testEnv.Auth.username,
    // sitterApiTokenPass: AppData.apigee.testEnv.Auth.password
    sitterApiToken: AppData.sitterApiToken, //AppData.sitterApiToken,
    incubatorToken: AppData.config.clientId//AppData.incubatorToken
  }

  let token = await getAccessToken(settings);
  let items = await getRelatedSitters(token.data.access_token);
  if (!items) {
    debugger
    $("#cities").prop("disabled", true);
    alert('لم يتم العثور على بيانات للحاضنات');
    return;
  }
  if (items.data.data.responseCode === 2) {
    //console.log(items);
    return;
  }
  debugger
  let migratedRelatedSitter = await getGisDataMigratedWithBaladyData(items.data.data.result);
  console.log('migratedRelatedSitter', migratedRelatedSitter);
  let selectedFeature;
  let sitterPointFeature = [];
  if (migratedRelatedSitter.features.length > 0) {
    for (let index = 0; index < migratedRelatedSitter.features.length; index++) {
      const el = migratedRelatedSitter.features[index];
      //AppData.migratedRelatedSitter = el;
      addGraphic(sitterGraphicLayer, el, false);
      //sitterPointFeature = AppData.migratedRelatedSitter;
      //sitterPointFeature.geometry = AppData.migratedRelatedSitter.geometry.centroid;
      addGraphicOnEdite(sitterPointGraphicLayer, el, false, AppData.assets.images.mapMarker);
    }

    selectedFeature = migratedRelatedSitter.features.filter(x => x.attributes.GUID == AppData.config.guid);
    debugger
    $("#cities").prop("disabled", true);
    if (selectedFeature.length > 0) {
      //addGraphic(sitterGraphicLayer, gisData.features[0].geometry, false);
      debugger
      setTimeout(() => {
        dropDownItem == 'cities' ?
          zoomToFeature(selectedFeature[0].geometry, AppData.mapView) : null;
        addGraphicToMap(selectedFeature[0].geometry, AppData.mapView);
      }, 1200);

      if (dropDownItem == 'cities') {
        setTimeout(() => {
          getSelectedItemDetail(selectedFeature[0].attributes);
          //console.log(selectedFeature[0])
          showMapPopupUpd(selectedFeature[0], AppData.mapView, selectedFeature[0].geometry.centroid);
        }, 1200);
      }
    } else {
      alert('لا توجد بيانات للحاضنة المرسلة فى قاعدة البيانات الجغرافية');
    }
  } else {
    showNotification('info', `${'👈'} خطا`, 'لا توجد بيانات جغرافية للبيانات المرسله');
    showHideLoading('none');
  }

  // if (gisData.features.length > 0) {
  //   $("#cities").prop("disabled", true);
  //   //addGraphic(sitterGraphicLayer, gisData.features[0].geometry, false);
  //   zoomToFeature(selectedFeature[0].geometry, AppData.mapView);
  //   addGraphicToMap(selectedFeature[0].geometry, AppData.mapView);
  // }
}

async function getRelatedSitters(token) {
  let url = `${AppData.apiendpoint.INTG.relatedSitters}${parseInt(AppData.config.sitterId)}/${AppData.sellingPortDropdownValue || 201}`;
  if (AppData.distrectValueDropdown) {
    url = `${AppData.apiendpoint.INTG.relatedSitters}${parseInt(AppData.config.sitterId)}/${AppData.sellingPortDropdownValue || 201}?district=${AppData.distrectValueDropdown}`
  }
  if (AppData.streeItemtId) {
    url = `${AppData.apiendpoint.INTG.relatedSitters}${parseInt(AppData.config.sitterId)}/${AppData.sellingPortDropdownValue || 201}?district=${AppData.distrectValueDropdown}&street=${AppData.streeItemtId}`
  }
  let relatedSitter = await axios.get(url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  }).catch(err => {
    console.log(err);
    $("#cities").prop("disabled", true);
    alert('لم يتم العثور على بيانات الحاضنة');
  })
  return relatedSitter;
}
async function getGisDataMigratedWithBaladyData(baladyData) {
  debugger
  let baladyfeatures = baladyData;
  AppData.sittersdata = baladyfeatures;
  let whereCondition = await GUIDHandler(baladyData);
  //console.log(whereCondition);
  options = {
    LayerURL: AppData.streetVendorMapServer,
    where: whereCondition,
    outFields: ['GUID']
  }
  let geometryData = await getgeometryUsingGUID(options);
  if (geometryData == null) {
    alert('برجاء المحاولة مرة اخرى الخدمة الجغرافية غير متوفرة');
    return false;
  }
  if (geometryData.features.length > 0) {
    for (let index = 0; index < geometryData.features.length; index++) {
      const el = geometryData.features[index];
      let featureGUID = el.attributes.GUID;
      let baladyData = AppData.sittersdata.filter(item => item.krokiGuid === featureGUID);
      bindDataToFeature(el, baladyData);
    }
    //AppData.gisData = geometryData.features;
  }
  return geometryData;
}

function bindDataToFeature(el, baladyData) {
  el.attributes.districtId = baladyData[0].districtId;
  el.attributes.districtName = baladyData[0].districtName;
  el.attributes.endDate = baladyData[0].endDate;
  el.attributes.id = baladyData[0].id;
  el.attributes.krokiGuid = baladyData[0].krokiGuid;
  el.attributes.municipalityId = baladyData[0].municipalityId;
  el.attributes.municipalityName = baladyData[0].municipalityName;
  el.attributes.name = baladyData[0].name;
  el.attributes.requestId = baladyData[0].requestId;
  el.attributes.startDate = baladyData[0].startDate;
  el.attributes.streetId = baladyData[0].streetId;
  el.attributes.streetName = baladyData[0].streetName;
  el.attributes.subMunicipalityId = baladyData[0].subMunicipalityId;
  el.attributes.subMunicipalityName = baladyData[0].subMunicipalityName;
}

async function GUIDHandler(items) {
  let arr = items.map(e => e.krokiGuid).join(',');
  let splitStr = arr.split(',');
  let Mystr = '';
  for (let index = 0; index < splitStr.length; index++) {
    const el = splitStr[index];
    Mystr += index == splitStr.length - 1 ? `'${el}'` : `'${el}',`
  }
  let buildStr = `GUID IN (${Mystr})`;
  return buildStr;
}

async function sitterDataHandler(sitterItem) {
  let options = {};
  let result = [];
  let feature = [];
  feature.attributes = {};
  sitterItem.map(async item => {

    feature.attributes = {
      districtId: item.districtId,
      districtName: item.districtName,
      endDate: item.endDate,
      id: item.id,
      krokiGuid: item.krokiGuid,
      municipalityId: item.municipalityId,
      municipalityName: item.municipalityName,
      name: item.name,
      requestId: item.requestId,
      startDate: item.startDate,
      streetId: item.streetId,
      streetName: item.streetName,
      subMunicipalityId: item.subMunicipalityId,
      subMunicipalityName: item.subMunicipalityName,
    },
      feature.geometry = null
    result.push(feature);
  })
  return result;
}

async function getDistrectGeometry(id) {
  AppData.distrectValueDropdown = id;
  let streetsSelect = document.querySelector('#streets');
  streetsSelect.options.length = 0;
  let index = AppData.dropDown.distrect.data.findIndex(el => el.item.DISTRICTCODE === id)
  if (index != -1) {
    let geometry = AppData.dropDown.distrect.data[index].geometry
    addGraphicToMap(geometry, AppData.mapView);
    zoomToFeature(geometry, AppData.mapView);
    let streetOptions = {
      LayerURL: `${AppData.MomraBasemap}/${AppData.layerIndexInMomraBasemap.streets}`,//AppData.Street,
      where: "STREETNAME IS NOT NULL",
      outFields: ['STREETCODE,STREETNAME'],
      spatialRelationship: "contains",
      geometry: geometry
    }

    let streets = await getStreetData(streetOptions)
    AppData.dropDown.streets.data = streets;
    bindOptionToSelect(streetsSelect, streets, 'STREETCODE', 'STREETNAME', null, 'اختر الشارع');
    streetsSelect.length > 0 ? streetsSelect.disabled = false : streetsSelect.disabled = true;
  } else {
    streetsSelect.options.length = 0;
    streetsSelect.disabled = true;
  }
  //loadSitterData(accessToken, AppData.citiesValueDropdown, id, null, AppData.sellingPortDropdownValue || 201);
  loadSitterBasedOnMode(accessToken, AppData.citiesValueDropdown, id, null, AppData.sellingPortDropdownValue || 201, 'distrects');
}

function getStreetGeometry(id) {
  AppData.streeItemtId = id;
  let index = AppData.dropDown.streets.data.findIndex(el => el.item.STREETCODE === id);
  if (index != -1) {
    let geometry = AppData.dropDown.streets.data[index].geometry;
    addGraphicToMap(geometry, AppData.mapView);
    zoomToFeature(geometry, AppData.mapView);
  }
  //loadSitterData(accessToken, AppData.citiesValueDropdown, AppData.distrectValueDropdown, id, AppData.sellingPortDropdownValue || 201);
  loadSitterBasedOnMode(accessToken, AppData.citiesValueDropdown, AppData.distrectValueDropdown, id, AppData.sellingPortDropdownValue || 201, 'streets');
}

// function bindDistrect(geometry) {
//   return dataHandler(options).then(redData => {
//     return redData.features.map(item => { return { item: item.attributes, geometry: item.geometry } });
//   })
// }


/**
 * cascading-dropDown onChange Event
 * @param {*} event 
 */
function onSelectChange(event) {
  debugger
  if (event && event.target.id === "sellingPort") {
    AppData.sellingPortDropdownValue = event.target.value;
  }
  else if (event && event.target.id === "regions") {
    getRegionsGeometry(event.target.value);
  }
  else if (event && event.target.id === "cities") {
    getCitiesGeometry(event.target.value);
  }
  else if (event && event.target.id === "distrect") {
    getDistrectGeometry(event.target.value);
  }
  else if (event && event.target.id === "streets") {
    getStreetGeometry(event.target.value);
  }
  AppData.isProduction == false ? console.log(event) : null;
}

/**
 * start Query with any Gis layer without geometry
 * @param {Object} options 
 * @returns 
 */
function dataHandler(options) {
  return queryTaskAsync({
    url: options.LayerURL,
    where: options.where,// "1=1",
    outFields: options.outFields,
    mode: queryMode.Features,
    returnGeometry: true,
  });
}




/**
 * start Query with any Gis layer with geometry
 * @param {Object} options 
 * @returns 
 */
function dataHandlerUsingGometry(options) {
  return queryTaskAsync({
    url: options.LayerURL,
    where: options.where,//"1=1",
    outFields: options.outFields,
    mode: queryMode.Features,
    geometry: options.geometry,
    spatialRelationship: options.spatialRelationship || "intersects ",
    returnGeometry: true,
    distance: options.distance || null,
    units: options.units || null
  });
}

/**
 * get data by GUID
 * @param {*} options 
 * @returns 
 */
function getgeometryUsingGUID(options) {
  return dataHandlerGetGometry(options).then(respones => {
    return respones;
  }).catch(err => {
    console.log(err)
    return null;
  })
}

function dataHandlerGetGometry(options) {
  return queryTaskAsync({
    url: options.LayerURL,
    where: options.where,
    outFields: options.outFields,
    mode: queryMode.Features,
    returnGeometry: true,
  });
}

function getAccessToken(settings) {
  debugger
  try {
    let url = settings.sitterApiToken;
    let token = AppData.config.clientId;
    const params = new URLSearchParams();
    return axios.post(url, {
      "incubatorToken": token
    }, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
  } catch (error) {

  }
}

// function getSitterData(token, cities, distrect = null, street = null, portType = 201) {
//   debugger
//   AppData.sittersdata = null;
//   let url = null;
//   url = `${AppData.sittersApi}/${cities}/${portType}`;
//   if (distrect != null) {
//     url = url.concat(`?distrect=${distrect}`)
//     //console.log(url);
//   }
//   if (street != null) {
//     url = url.concat(`&street=${street}`)
//     //console.log(url);
//   }
//   AppData.isProduction == false ? console.log(url) : null;
//   try {
//     return axios.get(`${AppData.sittersApi}/${cities}/${portType}`, {
//       headers: {
//         Authorization: 'Bearer ' + token
//       }
//     })
//       .catch(async error => {
//         if (error.response && error.response.status === 401) {
//           let settings = {
//             sitterApiToken: AppData.sitterApiToken,//AppData.sitterApiToken,
//             incubatorToken: AppData.config.clientId//AppData.incubatorToken
//           }
//           let generateAccesstoken = await getAccessToken(settings);
//           if (generateAccesstoken.status === 200) {
//             accessToken = generateAccesstoken.data.access_token;
//             loadSitterData(accessToken, cities, null, null, AppData.sellingPortDropdownValue || 201);
//           } else {
//             console.log('الخدمة غير متاحة برجاء مراجعة الدعم الفنى');
//           }
//         }
//       })
//   } catch (error) {
//     throw new Error({ "message": "token generated now" });
//   }
// }

/**
 * check application mode
 * @param {*} config 
 * @returns 
 */
// function isEditeMode(config) {
//   if ('isEditable' in config) {
//     if ('guid' in config &&
//       'cityId' in config &&
//       config.guid.length > 0 &&
//       config.cityId.length > 0 &&
//       config.isEditable == true) {
//       return true
//     }
//   } else {
//     return false
//   }
// }


/** new implementation for map*/
// function isExportGoogleMode(config) {
//   if ('exportIncubatorToGoogle' in config &&
//     config.exportIncubatorToGoogle == true &&
//     config.isEditable == false &&
//     config.guid.length > 0) {
//     return true;
//   } else {
//     return false;
//   }
// }

/**
 * check application حجز موقع عربة
 * @param {*} config 
 * @returns 
 */
function isSitterPortPaths(config) {
  if (config.hasOwnProperty('sitterPortPaths')) {
    if (config.sitterPortPaths.length > 0) {
      return true;
    }
  }
  return false;
}

async function getIncubatorByGUID(config) {
  let incubatorSettings = {
    LayerURL: config.streetVendorMapServer,
    where: `GUID='${config.config.guid}'`
  }
  let gisData = await getgeometryUsingGUID(incubatorSettings);
  return gisData;
}

function sendToGoole(point) {
  window.open(`https://www.google.com/maps?q=${point.y},${point.x}&z=1`, '_blank');
}

async function generateRequestId(url) {
  let requestId = getCookie(AppData.appId);
  axios.post(url, {
    "appId": requestId
  }, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}

function setCookie(value, appId) {
  const d = new Date();
  const exdays = 1;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = appId + "=" + value + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}